import React, { useContext, useState } from "react";
import { REGISTER_IN } from "../../api";
import { AccountContext } from "../../context/accountContext";
import {
  BoldLink,
  BoxContainer,
  FormContainer,
  Input,
  MutedLink,
  SubmitButton,
} from "../../styles/communityCommon";
import { Marginer } from "../Marginer";

export function SignupForm(props) {
  const { switchToSignin } = useContext(AccountContext);

  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const registerHanlder = () => {
    // CALL REG API
    if (
      userName &&
      userEmail &&
      password &&
      password == confirmPassword &&
      firstName &&
      lastName
    ) {
      REGISTER_IN({
        username: userName,
        email: userEmail,
        password: password,
        firstName: firstName,
        lastName: lastName,
      })
        .then((res) => {
          console.log("Resgister res: ", res);
          switchToSignin();
        })
        .catch((er) => {
          console.log("Rergister Error: ", er);
        });
    }
  };

  return (
    <BoxContainer>
      <FormContainer>
        <Input
          type="text"
          placeholder="FirstName"
          onChange={(e) => {
            setFirstName(e.target.value);
          }}
        />
        <Input
          type="text"
          placeholder="LasName"
          onChange={(e) => {
            setLastName(e.target.value);
          }}
        />
        <Input
          type="text"
          placeholder="Username"
          onChange={(e) => {
            setUserName(e.target.value);
          }}
        />
        <Input
          type="email"
          placeholder="Email"
          onChange={(e) => {
            setUserEmail(e.target.value);
          }}
        />
        <Input
          type="password"
          placeholder="Password"
          onChange={(e) => {
            setPassword(e.target.value);
          }}
        />
        <Input
          type="password"
          placeholder="Confirm Password"
          onChange={(e) => {
            setConfirmPassword(e.target.value);
          }}
        />
      </FormContainer>
      <Marginer direction="vertical" margin={10} />
      <SubmitButton type="submit" onClick={registerHanlder}>
        Signup
      </SubmitButton>
      <Marginer direction="vertical" margin="1em" />
      <MutedLink href="#">
        Already have an account?
        <BoldLink href="#" onClick={switchToSignin}>
          Signin
        </BoldLink>
      </MutedLink>
    </BoxContainer>
  );
}
